import script from "./CreateDiscussionAtom.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateDiscussionAtom.vue?vue&type=script&setup=true&lang=ts"

import "./CreateDiscussionAtom.vue?vue&type=style&index=0&id=7c35d027&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c35d027"]])

export default __exports__